import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';

const MAIN_LINKS = [
  { to: '/', label: 'Accueil', exact: true },
  { to: '/villes', label: 'Villes' },
  { to: '/blog', label: 'Guide' },
  { to: '/accompagnement', label: 'Accompagnement' },
];

const TOOLS_LINKS = [
  { to: '/simulateurs', label: 'Simulateurs' },
  { to: '/calculateur-net', label: 'Calculateur Net' },
  { to: '/comparateur', label: 'Comparateur' },
  { to: '/profil-investisseur', label: 'Profil investisseur' },
];

const MOBILE_ALL_LINKS = [
  { to: '/', label: 'Accueil', exact: true },
  { to: '/villes', label: 'Villes' },
  { to: '/simulateurs', label: 'Simulateurs' },
  { to: '/calculateur-net', label: 'Calculateur Net' },
  { to: '/comparateur', label: 'Comparateur' },
  { to: '/profil-investisseur', label: 'Profil investisseur' },
  { to: '/blog', label: 'Guide' },
  { to: '/accompagnement', label: 'Accompagnement' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [toolsOpen, setToolsOpen] = useState(false);

  const isToolsActive = TOOLS_LINKS.some(l => window.location.pathname.startsWith(l.to));

  return (
    <header className="header">
      <div className="container header-inner">
        <Link to="/" className="logo" onClick={() => setOpen(false)}>
          <span className="logo-monogram">II</span>
          <div>
            <span className="logo-name">Deal Israel</span>
            <span className="logo-tagline">Les meilleurs deals immobiliers en Israël</span>
          </div>
        </Link>
        <nav className="nav-desktop">
          {MAIN_LINKS.map(l => (
            <NavLink key={l.to} to={l.to} end={l.exact}
              className={({ isActive }) => `nav-link${isActive ? ' nav-link--active' : ''}`}>
              {l.label}
            </NavLink>
          ))}
          {/* Outils dropdown */}
          <div
            className={`nav-dropdown${isToolsActive ? ' nav-dropdown--active' : ''}`}
            onMouseEnter={() => setToolsOpen(true)}
            onMouseLeave={() => setToolsOpen(false)}>
            <button className={`nav-link nav-dropdown-trigger${isToolsActive ? ' nav-link--active' : ''}`}>
              Outils
            </button>
            {toolsOpen && (
              <div className="nav-dropdown-menu">
                {TOOLS_LINKS.map(l => (
                  <NavLink key={l.to} to={l.to}
                    className="nav-dropdown-item"
                    onClick={() => setToolsOpen(false)}>
                    {l.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        </nav>
        <Link to="/accompagnement" className="btn btn-accent btn-sm header-cta">Être accompagné</Link>
        <button className={`burger${open ? ' burger--open' : ''}`} onClick={() => setOpen(!open)}>
          <span /><span /><span />
        </button>
      </div>
      {open && (
        <div className="nav-mobile">
          <div className="container">
            {MOBILE_ALL_LINKS.map(l => (
              <NavLink key={l.to} to={l.to} end={l.exact}
                className={({ isActive }) => `nav-mobile-link${isActive ? ' nav-mobile-link--active' : ''}`}
                onClick={() => setOpen(false)}>{l.label}</NavLink>
            ))}
            <Link to="/accompagnement" className="btn btn-accent"
              style={{ width: '100%', justifyContent: 'center', marginTop: '1rem' }}
              onClick={() => setOpen(false)}>Être accompagné</Link>
          </div>
        </div>
      )}
    </header>
  );
}
